import { MetadataPlugin } from "./metadata";

export const createTimestampPlugin: MetadataPlugin<number> = function () {
  function getValue() {
    return {
      ts: new Date().getTime(),
    };
  }

  return {
    getValue,
  };
};
